import React from "react"

import CareersIndex from "@components/careers-index"

export default ({ pageContext: project }) => (
  <CareersIndex projectName={project.name} />
)
